/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, February 10th 2022, 5:21:48 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { FormMany2OnePicker, FormInfoPopUpForm } from "form-builder/components";
import { getFormConfiguration } from "lib/factories";
import { TaskTemplate, FORM_STATUS_CHOICES_ENUM } from "lib/schemas";
import { useServiceBuilderContext } from "service-builder/providers";
import { useOSFormContext } from "ui-widgets/forms/providers";
import { UserTaskCommonSettings } from "./UserTaskCommonSettings";

export const ReviewTaskSettings = () => {
  const {
    processDefinitionContext: { currentProcessDefinition },
  } = useServiceBuilderContext();

  const { watch } = useOSFormContext<TaskTemplate>();

  const watchedTaskTitle = watch<keyof TaskTemplate>("title");

  const defaultNewFormConfiguration = getFormConfiguration(currentProcessDefinition.artifact_org, {
    form_type: "review_form",
    title: `${watchedTaskTitle} Form`,
    status: FORM_STATUS_CHOICES_ENUM.Published,
    login_required: true,
    sites: [currentProcessDefinition.site],
  });

  return (
    <>
      <FormMany2OnePicker<TaskTemplate>
        schema_field_key="user_action_form"
        label="Assessment Form"
        apiQueryParams={{ form_type: "review_form" }}
        renderRelatedObjectForm={({ updatePrimaryObject, closeNewFormFn, newFormOpenState }) => (
          <FormInfoPopUpForm
            closeFormInfoPopUpFn={closeNewFormFn}
            formInfoPopUpOpenState={newFormOpenState}
            defaultNewFormConfiguration={defaultNewFormConfiguration}
            popUpTitle="New Assessment Form"
            onAPISaveFormInfoCallBackFn={(formConfiguration) => updatePrimaryObject(formConfiguration.id)}
          />
        )}
      />

      <UserTaskCommonSettings />
    </>
  );
};
